/**
 * @module router/guards/roleGuard
 * @description 역할 기반 라우트 가드 — `meta.roles` 배열에 명시된 사용자 유형만 진입을 허용합니다.
 * meta.roles 가 부재하거나 빈 배열이면 통과(기존 라우트 호환). 미충족 시 안내 후 /dashboard 로 리다이렉트합니다
 * (안내 문구는 menuGuard 와 같다 — SURINP-692).
 * authGuard 통과 이후에 호출되어야 의미가 있습니다(인증된 사용자에 한해 권한 검사).
 */
import store from '@/store'
import i18n from '@/locales/i18n'

/**
 * meta.roles 검사. 미충족 시 /dashboard 리다이렉트.
 *
 * @param {import('vue-router').RouteLocationNormalized} to - 이동할 라우트
 * @param {import('vue-router').RouteLocationNormalized} from - 현재 라우트
 * @param {import('vue-router').NavigationGuardNext} next - 다음 라우트 진행 함수
 * @returns {boolean} 리다이렉트가 발생한 경우 true, 통과한 경우 false
 */
export const roleGuard = (to, from, next) => {
  const requiredRoles = to.meta && to.meta.roles
  if (!Array.isArray(requiredRoles) || requiredRoles.length === 0) return false
  const user = store.state && store.state.auth && store.state.auth.user
  const userType = user && user.id && user.id.userType
  if (!userType || !requiredRoles.includes(userType)) {
    window.appAlert(i18n.global.t('message.noMenuPermission'), 'warning')
    next({ path: '/dashboard' })
    return true
  }
  return false
}
